export enum ReservationChangeType {
  CHECK_IN_DATE,
  CHECK_OUT_DATE,
  NUMBER_OF_ADULTS,
  NUMBER_OF_CHILDREN,
  NUMBER_OF_ROOMS,
  RATE,
  ROOM,
  ADDITIONAL_GUEST_NAMES,
  GROUP_CODE
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/change/reservation-change.model.ts